import axios from "axios";
import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import auth, { getCurrentUser } from "../../services/authService";
import styles from "./ThirdAscensionBreakAreaEntrance.module.css";
function ThirdAscensionBreakAreaEntrance() {
  useEffect(() => {
    localStorage.setItem(
      "selectedEventName",
      window.location.href.split("//")[1].split("/")[1]
    );

    axios
      .post(`${process.env.REACT_APP_SERVER_URL}projects/getprojectbypath`, {
        path: window.location.href,
      })
      .then((res) => {
        if (res.data._id !== undefined) {
          axios
            .post(
              `${process.env.REACT_APP_SERVER_URL}stats/setpage/breakroomEntrance`,
              {
                id: res.data._id,
              }
            )
            .then((res) => {});
        }
      });
  }, []);
  let history = useNavigate();
  return (
    <div>
      <div className={styles["mentor-card-screen-background"]}>
        <div className='col-md-12 col-xs-12'>
          <div className='row'>
            <div
              className={styles["btn-back-envirtual-container"] + " col-md-12"}
              onClick={() => {
                history("/asc3/hall");
              }}
            >
              <img src='/assets/back-btn.svg' className={styles["ddl"]}></img>
              <label className={styles["back-btn-label"]}>Back</label>
            </div>
          </div>
          <div className={styles["main"] + " row"}>
            <div className={styles["main-div"]}>
              <img src='/assets/thirdAscension/Camera.svg'></img>
              <span className={styles["header-text"]}>Photo booth</span>

              <div
                style={{ display: "flex", flexDirection: "row" }}
                className='mt-4'
              >
                <button
                  className={styles["btn-styling"]}
                  onClick={() => {
                    history("/asc3/photoboothentrance");
                  }}
                >
                  Go to Photobooth
                </button>
              </div>
            </div>
            <div className={styles["main-div"]}>
              <img src='/assets/thirdAscension/GameController.svg'></img>
              <span className={styles["header-text"]}>Game room</span>

              <div
                style={{ display: "flex", flexDirection: "row" }}
                className='mt-4'
              >
                <button
                  className={styles["btn-styling"]}
                  onClick={() => {
                    history("/asc3/gameentrance");
                  }}
                >
                  Go to Game Room
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThirdAscensionBreakAreaEntrance;
